module.exports = __webpack_public_path__ + "components/home-header/static/header-6--huge@2x-bfa3c61a7dd3db7c572d661f263bd21e.jpg";